import React from 'react'

const ErrorPage = () => {
  return <div className='error-page'>Ошибка при переводе</div>
}

export default ErrorPage
